wbApp.filter('groupsColors', ['$translate', 'groupSvc',
    function ($translate, groupSvc) {

        var models = groupSvc.getAllAsync();

        function asyncResult(input) {
            if (models.$resolved) {
                var selected = _.flatten(_.map(input, function (item) {
                    return _.filter(models, function(m) { return m.groupID == item; });
                }));

                if (selected.length > 0) {
                    var colorUtils = new webooker_utils.ColorUtils();
                    return _.map(selected, function (s) {
                        var title = selected.length > 1
                            ? "POZOR! Tento záznam má přiřazeno více skupin, reporty pro MPSV se nemusí generovat správně!"
                            : s.name;

                        return "<span style='background-color:" + colorUtils.intToRgb(s.color || 0) +
                            "; width: 30px; height: 21px; display:inline-block; border: 1px solid #ddd'" +
                            "title='" + title + "'" +
                            ">&nbsp;</span>";
                    }).join(' ')
                } else {
                    return '';
                }
            } else {
                return $translate.instant('TXT_LOADING_DATA');
            }
        }

        asyncResult.$stateful = true;

        return asyncResult;
    }]
);